import firebaseConfig from './firebase-configs/firebase-config.prod.json';

export const environment = {
  production: true,
  emulator: false,
  emulateFirestore: false,
  e2e: false,
  firebase: firebaseConfig,
};
